import { BrowserRouter, Switch, Route } from 'react-router-dom'
import Home from './pages/home/Home';
import Landing from './pages/landing/Landing'
import Login from './pages/login/Login'
import SignUp from './pages/signup/SignUp'
import Confirm from './pages/confirm/Confirm'

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Switch>
        <Route path='/confirm/:token'>
            <Confirm />
          </Route>
          <Route path='/home'>
            <Home />
          </Route>
          <Route path='/signup'>
            <SignUp />
          </Route>
          <Route path='/login'>
            <Login />
          </Route>
          <Route path='/'>
            <Landing />
          </Route>
        </Switch>
      </BrowserRouter>
    </div>
  );
}
